import { createRouter, createWebHistory } from 'vue-router'
import { h, resolveComponent } from 'vue'
import DefaultLayout from '@/layouts/DefaultLayout'
import {isAuthenticated} from "@/helpers/back";

const routes = [
  {
    path: '/receipt',
    name: 'Чеки',
    component: DefaultLayout,
    redirect: '/receipt/payments',
    meta: { requiresAuth: true},
    children: [

      {
        path: '/payouts',
        name: 'Выплаты',
        meta: { title: 'Выплаты'},
        component: () =>
          import(
            '@/views/payouts/PayoutsList.vue'
          ),
      },

      {
        path: '/payouts/history',
        name: 'Выплаты История',
        meta: { title: 'Выплаты История'},
        component: () =>
          import(
            '@/views/payouts/PayoutsHistory.vue'
          ),
      },

      {
        path: '/payouts/dashboard',
        name: 'Панель выплат',
        meta: { title: 'Панель выплат'},
        component: () =>
          import(
            '@/views/payouts/PayoutsDashboard.vue'
          ),
      },

      {
        path: '/settings/cashregs',
        name: 'Кассы',
        meta: { title: 'Кассы'},
        component: () =>
          import(
            '@/views/receipts/SettingsCashregs.vue'
          ),
      },
      {
        path: '/settings/companies',
        name: 'Организации',
        meta: { title: 'Организации'},
        component: () =>
          import(
            '@/views/receipts/SettingsCompanies.vue'
          ),
      },
      {
        path: '/settings/rscenarious',
        name: 'Сценарии Чеков',
        meta: { title: 'Сценарии Чеков'},
        component: () =>
          import(
            '@/views/receipts/SettingsScenarious.vue'
          ),
      },
      {
        path: 'statistics',
        name: 'Статистика',
        meta: { title: 'Чеки статистика'},
        component: () =>
          import(
            '@/views/dashboards/PaymentsDashboard.vue'
          ),
      },
      {
        path: 'payments',
        name: 'Платежи',
        meta: { title: 'Платежи'},
        component: () =>
          import(
            '@/views/receipts/Payments.vue'
          ),
      },
      {
        path: 'payments-by-days',
        name: 'Платежи по дням',
        meta: { title: 'Платежи по дням'},
        component: () =>
          import(
            '@/views/receipts/PaymentsByDays.vue'
          ),
      },


    ]
  },

  {
    path: '/product',
    name: 'Продукты',
    component: DefaultLayout,
    redirect: '/product/list',
    meta: { requiresAuth: true},
    children: [
      {
        path: 'list',
        name: 'Продукты Список',
        meta: { title: 'Продукты Список'},
        component: () =>
          import(
            '@/views/products/ProductsList.vue'
          ),
      },
    ]
  },

  {
    path: '/users',
    name: 'Пользователи',
    component: DefaultLayout,
    redirect: '/users/list',
    meta: { requiresAuth: true},
    children: [
      {
        path: 'list',
        name: 'Пользователи Список',
        meta: { title: 'Пользователи Список'},
        component: () =>
          import(
            '@/views/users/UsersList.vue'
          ),
      },
      {
        path: 'id/:id',
        name: 'Партнер',
        meta: { title: 'Партнер'},
        props: true,
        component: () =>
          import(
            '@/views/users/UserView.vue'
          ),
      },
    ]
  },

  {
    path: '/',
    name: 'Главная',
    component: DefaultLayout,
    redirect: '/dashboard4',
    meta: { requiresAuth: true},
    children: [
      {
        path: '/dashboard4',
        name: 'Сводная',
        meta: { title: 'Сводная'},
	  	props: true,
        component: () =>
          import(
            '@/views/dashboards/Dashboard4.vue'
          ),
      },
      {
        path: 'tarifs',
        name: 'tarifs',
        meta: { title: 'Тарифы'},
        component: () =>
          import(
            '@/views/tarif/TarifsList.vue'
          ),
      },
      {
        path: '/content',
        name: 'Контент',
        meta: { title: 'Контент'},
        component: () =>
          import(
            '@/views/content/ContentList.vue'
          ),
      },
      {
        path: '/platform/dashboard',
        name: 'Обслуживание платформы',
        meta: { title: 'Обслуживание платформы'},
        component: () =>
          import(
            '@/views/platform/PlatformDashboard.vue'
          ),
      },
      {
        path: '/platform/payment-generator',
        name: 'payment_generator',
        meta: { title: 'Генератор платежа'},
        component: () =>
          import(
            '@/views/platform/PaymentGenerator.vue'
          ),
      },
      {
        path: '/platform/report-generator',
        name: 'report_generator',
        meta: { title: 'Генератор отчета'},
        component: () =>
          import(
            '@/views/platform/ReportGenerator.vue'
          ),
      },
      {
        path: '/landings',
        name: 'landings',
        meta: { title: 'Лендинги'},
        component: () =>
          import(
            '@/views/content/LandingsList.vue'
          ),
      },
      {
        path: '/visits',
        name: 'visits',
        meta: { title: 'Посещаемость'},
        component: () =>
          import(
            '@/views/visits/VisitsList.vue'
          ),
      },
      {
        path: '/money',
        name: 'money',
        meta: { title: 'Деньги'},
        component: () =>
          import(
            '@/views/money/Money1.vue'
          ),
      },
      {
        path: '/money2',
        name: 'money2',
        meta: { title: 'Деньги 2'},
        component: () =>
          import(
            '@/views/money/Money2.vue'
          ),
      },
      {
        path: '/comments',
        name: 'Комментарии',
        meta: { title: 'Комментарии'},
        component: () =>
          import(
            '@/views/content/CommentsList.vue'
          ),
      },
      {
        path: '/subs',
        name: 'Подписки',
        meta: { title: 'Подписки'},
        component: () =>
          import(
            '@/views/subs/SubsListView.vue'
          ),
      },
      {
        path: '/leadrules',
        name: 'leadrules',
        meta: { title: 'Ставки за Лид'},
        component: () =>
          import(
            '@/views/leadrule/LeadRuleList.vue'
          ),
      },
      {
        path: '/users-lost',
        name: 'users-lost',
        meta: { title: 'Потерянные Партнеры'},
        component: () =>
          import(
            '@/views/users/UsersLost.vue'
          ),
      },
      {
        path: '/sub/account-id/:account_id',
        name: 'sub_by_account_id',
	  	props: true,
        meta: { title: 'Подписка'},
        component: () =>
          import(
            '@/views/subs/SubOne.vue'
          ),
      },
      {
        path: '/sub/id/:entry_id',
        name: 'sub_by_id',
	  	props: true,
        meta: { title: 'Подписка'},
        component: () =>
          import(
            '@/views/subs/SubOne.vue'
          ),
      },
      {
        path: '/tarif/report',
        name: 'tarif_stats',
        meta: { title: 'Тарифы статистика'},
        component: () =>
          import(
            '@/views/tarif/TarifReport.vue'
          ),
      },
    ],
  },



  {
    path: '/',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404'),
      },
      {
        path: '500',
        name: 'Page500',
        component: () => import('@/views/pages/Page500'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/pages/Login'),
        meta:{title:'Авторизация'}
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import('@/views/pages/Register'),
        meta:{title:'Регистрация'}
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  // if (to.meta.requiresAuth && !await isAuthenticated(null, 'admin')) {
  if (to.meta.requiresAuth && !await isAuthenticated(null, null)) {
    next('/login')
  } else {
    next()
  }
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  document.title = routeTo.meta.title
  next()
})

const metrikaIds = [103285269];
router.afterEach((to) => {
  if (window?.ym) {
    metrikaIds.forEach(id => {
      window.ym(id, 'hit', to.fullPath);
    });
  }
});


export default router
